export class RemoveEmployeeFromVenueModel {
  public employeeId: string;
  public venueId: string;
}
